
import ActionTypes from 'redux/actions/ActionTypes';

export const createCloseShareModalAction = () => {
    return {
        type: ActionTypes.CloseShareModal,
    }
}
